<div class="main-container">

  <!-- ── Page header: title + Add new ───────────────────────────── -->
  <div class="customers-page-header">
    <h1><i class="address book outline icon"></i> Customers</h1>
    <button class="ui primary button" v-on:click="newContact">New Customer</button>
  </div>

  <!-- ── Search ──────────────────────────────────────────────────── -->
  <div class="customers-search-row">
    <app-text-input
      class="customers-search-input"
      icon="search"
      placeholder="Search by name, address, phone, email"
      v-model="searchText"
      @keyup="search"
    />
  </div>

  <!-- ── Import actions (conditional on connected integrations) ──── -->
  <div class="customers-import-row" v-if="xeroImportAvailable || sm8ImportAvailable">
    <button
      v-if="xeroImportAvailable"
      class="ui customers-import-btn button"
      v-bind:class="{ loading: xeroImporting, disabled: xeroImporting }"
      v-on:click="importXero"
      aria-label="Sync customers with Xero"
    >
      <img src="../../assets/img/icn_xero.svg" class="import-btn-logo" alt="Xero">
      Sync with Xero
    </button>

    <button
      v-if="sm8ImportAvailable"
      class="ui customers-import-btn button"
      v-bind:class="{ loading: sm8Importing, disabled: sm8Importing }"
      v-on:click="importSm8"
      aria-label="Sync customers with ServiceM8"
    >
      <img src="../../assets/img/icn_servicem8.png" class="import-btn-logo" alt="ServiceM8">
      Sync with SM8
    </button>
  </div>

  <!-- ── Contact table ───────────────────────────────────────────── -->
  <div class="ui grid customers-grid-wrapper">
    <div class="sixteen wide column">
      <div class="ui bottom attached active tab segment">
        <table class="ui basic selectable celled padded table customers-contact-table">
          <tbody>
            <template v-for="key in sectionKeys" :key="'sec-group-' + key">
              <tr :id="'contacts-section-' + key" class="contacts-section-row">
                <td colspan="4" class="contacts-section-header">{{ key }}</td>
              </tr>
              <tr
                v-for="contact in groupedContacts[key]"
                :key="contact.id"
                class="contact-row"
                v-on:click="goToCustomer(contact)"
              >
                <td>
                  <strong>{{ contact.company || contact.first_name + ' ' + contact.last_name }}</strong>
                  <div class="cell-sub-description" v-if="contact.company">{{ contact.first_name }} {{ contact.last_name }}</div>
                  <div class="cell-sub-description" v-if="contact.street_address">{{ contact.street_address }}, {{ contact.suburb }} {{ contact.state }} {{ contact.postcode }}</div>
                </td>
                <td :class="{ 'contact-cell-empty': isCellEmpty(contact.phone) }">{{ formatCell(contact.phone) }}</td>
                <td :class="{ 'contact-cell-empty': isCellEmpty(contact.mobile) }">{{ formatCell(contact.mobile) }}</td>
                <td :class="{ 'contact-cell-empty': isCellEmpty(contact.email) }">{{ formatCell(contact.email) }}</td>
              </tr>
            </template>
            <tr v-if="!loading && sectionKeys.length === 0">
              <td colspan="4" class="center aligned">Nothing to display</td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>

        <app-loader v-if="loading === true"></app-loader>
      </div>
    </div>

    <!-- ── Alphabetical letter rail (iCloud-style) ───────────────── -->
    <div
      v-if="!loading && sectionKeys.length > 0"
      class="contacts-letter-rail"
      ref="letterRail"
      v-on:pointerdown="onRailPointerDown"
      v-on:pointermove="onRailPointerMove"
      v-on:pointerup="onRailPointerEnd"
      v-on:pointercancel="onRailPointerEnd"
    >
      <span
        v-for="(item, idx) in railItems"
        :key="idx"
        class="rail-item"
        :class="{
          'rail-letter': item.type === 'letter',
          'rail-spacer': item.type === 'spacer',
          'rail-active': item.type === 'letter' && sectionKeySet[item.value]
        }"
      >{{ item.value }}</span>
    </div>
    <div
      v-if="railDragging && activeRailLetter"
      class="contacts-rail-bubble"
      :style="{ top: railBubbleTop + 'px' }"
    >{{ activeRailLetter }}</div>
  </div>

  <app-uploader
    v-if="uploadVisible"
    title="Import Contacts"
    para="Upload a comma separated values (CSV) file to import your contacts."
    url="/contact/import/csv"
    accept="*"
    @close="uploadVisible=false">
  </app-uploader>

</div>
